import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {AuditStageType, State} from '@features/audit-tracker/models/audit-tracker.models';
import {AuditTrackerService} from '@features/audit-tracker/services/audit-tracker.service';
import {select, Store} from '@ngrx/store';
import {getCurrentProject, ProjectState} from '@features/projects/store/reducers/projects.reducer';
import {map, skip, skipWhile, startWith, take, takeUntil} from 'rxjs/operators';
import {combineLatest, Observable, Subject} from 'rxjs';
import {MatOptionSelectionChange} from '@angular/material/core';
import {EntityChartApiService} from '@features/entity-chart/ed-entity-data/services/entity-chart-service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {CommandService} from '@core/services/command.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {getAllCountries, ParticleState} from '@shared/store/reducers/particle.reduer';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatAutocompleteSelectedEvent, MatAutocompleteTrigger} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {QueryProvider} from '@shared/queries/query-provider';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {TimeZoneService} from '@core/services/time-zone.service';

@Component({
    standalone: false,
    selector: 'app-add-audit-record-dialog',
  templateUrl: './add-audit-record-dialog.component.html',
  styleUrls: ['./add-audit-record-dialog.component.scss']
})
export class AddAuditRecordDialogComponent implements OnInit, IDialogView, OnDestroy {

  data: DialogModel;
  inputForm: any;
  projectId: string;
  entities: any[];
  filteredEntities: any[];
  stateList: any[];
  selectedStateList: any[];
  auditStageTypes: AuditStageType[];
  auditTypes: AuditStageType[];
  filteredOptions: Observable<any>;
  currentProject$: Observable<any>;
  private ngUnsubscribe = new Subject<void>();
  selectedCountryCode: string;
  isStateAvailable: boolean;
  possibleNewAuditType: boolean;
  auditTypeFilterdOption: Observable<AuditStageType[]>;
  private newFilteredItem: any;
  countryList: any[];
  possibleNewState: boolean;
  stateFilterdOptions: Observable<any>;
  private newStateItem: any;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  projectCountryCountsQueryKey = 'ProjectCountryCounts';
  dateError: string;
  minDate: Date;
  maxDate: Date;

  @ViewChild('stateInput', {static: true}) stateInput: ElementRef;
  @ViewChild(MatAutocompleteTrigger, {read: MatAutocompleteTrigger}) inputAutoComplete: MatAutocompleteTrigger;

  hasDateError: boolean;


  constructor(private formBuilder: FormBuilder,
              private auditTrackerService: AuditTrackerService,
              private entityChartApiService: EntityChartApiService,
              private projectStore: Store<ProjectState>,
              private particleStore: Store<ParticleState>,
              private queryStore: Store<IQueryState>,
              private fuseSplashScreen: FuseSplashScreenService,
              private snackBarService: SnackBarService,
              private commandService: CommandService,
              private platformQueryService: PlatformQueryService,
              private timeZoneService: TimeZoneService) {
    this.inputForm = this.formBuilder.group({
      title: ['', [
          Validators.required,
          Validators.pattern('[^\\\\/:*?\\"<>|]*')
      ]],
      // entity: [[], Validators.required],
      // state: [''],
      auditType: ['', Validators.required],
      taxYearStart: ['', Validators.required],
      taxYearEnd: ['', Validators.required],
      // fiscalYears: ['', Validators.required],
      // description: [''],
      // local: [''],
      // other: [''],
      countries: [[], Validators.required]
    });
  }

  ngOnInit(): void {
    this.minDate =  new Date(1000,1,1);
    this.maxDate =  new Date(9999,12,31);
    this.possibleNewAuditType = false;
    this.possibleNewState = false;
    this.selectedStateList = [];
    this.countryList = [];
    const query = new PlatformQuery();
    query.api = 'AuditTrackerApi';
    query.name = 'GetCountryListQuery';

    this.platformQueryService.executeQuery(query).subscribe(response => {
      if (response.fieldValues['CountryList']) {
        this.countryList = response.fieldValues['CountryList'];
      }
    });

    this.inputForm.valueChanges.subscribe(value => {
      this.data.isDisabledOkButton = this.inputForm.invalid;
    });
    // QueryProvider.invokeQuery(this.queryStore, this.projectCountryCountsQueryKey, {});
    // const projectCountryCounts$ = this.queryStore.pipe(takeUntil(this.ngUnsubscribe),
    //   select(getQueryResponse, this.projectCountryCountsQueryKey), skip(1));
    // const  allCountries$ = this.particleStore.pipe(takeUntil(this.ngUnsubscribe), select(getAllCountries));
    // // combine footprints with the countryh
    // combineLatest(allCountries$, projectCountryCounts$).subscribe(result => {
    //   if (result[0] && result[1]) {
    //     this.countryList = result[0];
    //     this.countryList.forEach(country => {
    //       if (result[1][country.code]) {
    //         country.actualEntityCount = result[1][country.code].EntityCount;
    //         country.historicalEntityCount = result[1][country.code].HistoricalEntityCount;
    //         country.proposedEntityCount = result[1][country.code].ProposedEntityCount;
    //         country.transactionCount = result[1][country.code].TransactionCount;
    //       }
    //     });
    //   }
    // });

    // this.currentProject$ = this.projectStore.pipe(select(getCurrentProject));
    // this.currentProject$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(currentProject => {
    //   if (currentProject) {
    //     this.projectId = currentProject.ProjectId;
    //     this.entityChartApiService.getEntities(currentProject.ProjectId).pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
    //       this.entities = res;
    //       this.entities = this.entities.sort( (a, b) => (a.fieldValues.EntityName < b.fieldValues.EntityName ? -1 :
    //         (a.fieldValues.EntityName > b.fieldValues.EntityName ? 1 : 0)));
    //       this.filteredEntities = this.entities;
    //     });
    //   }
    // });
    // this.getStates();

    this.auditTrackerService.getAuditTypes().pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
      this.auditTypes = res;
      this.registerForAuditTypeValueChange();
    });

  }

  private registerForAuditTypeValueChange() {
    this.auditTypeFilterdOption = this.inputForm.get('auditType').valueChanges
      .pipe(
        startWith(''),
        map(value => {
          const {displayText} = value as AuditStageType;
          return typeof value === 'string' ? value : displayText;
        }),
        map(name => name ? this._filter(name) : this.auditTypes.slice())
      );
  }

  onOkClicked(): boolean {
    const controls = [];
    // const entityControl = this.inputForm.controls['entity'];
    const titleControl = this.inputForm.controls['title'];
    controls.push(titleControl);
        // const stateControl = this.inputForm.controls['state'];
    const auditTypeControl = this.inputForm.controls['auditType'];
    controls.push(auditTypeControl);
    // const fiscalYearsControl = this.inputForm.controls['fiscalYears'];
    // const descriptionControl = this.inputForm.controls['description'];
    // const localControl = this.inputForm.controls['local'];
    // const otherControl = this.inputForm.controls['other'];
    const countriesControl = this.inputForm.controls['countries'];
    controls.push(countriesControl);
    const taxYearStartControl = this.inputForm.controls['taxYearStart'];
    controls.push(taxYearStartControl);
    const taxYearEndControl = this.inputForm.controls['taxYearEnd'];
    controls.push(taxYearEndControl);
    let hasError = false;
    for (const control of controls) {
      control.markAsTouched();
      if (control.hasError('required')) {
        hasError = true;
      }
    }
    if (hasError) {
      return false;
    }

    this.data.input['title'] = titleControl.value;
    // this.data.input['entity'] = entityControl.value;
    if (typeof auditTypeControl.value === 'string') {
      this.data.input['auditType'] = {
        displayText: auditTypeControl.value,
        id: auditTypeControl.value.toLowerCase(),
        stage: '',
        type: auditTypeControl.value
      };
    } else {
      this.data.input['auditType'] = auditTypeControl.value;
    }
    // this.data.input['fiscalYears'] = fiscalYearsControl.value;
    // this.data.input['description'] = descriptionControl.value;
    // this.data.input['projectId'] = this.projectId;
    // this.data.input['states'] = this.selectedStateList;
    this.data.input['countries'] = countriesControl.value;
    this.data.input['taxYearStart'] = this.timeZoneService.getUTCDateWithoutTime(taxYearStartControl.value);
    this.data.input['taxYearEnd'] = this.timeZoneService.getUTCDateWithoutTime(taxYearEndControl.value);
    // this.data.input['local'] = localControl.value;
    // this.data.input['other'] = otherControl.value;

    if ( new Date(taxYearStartControl.value) >= new Date(taxYearEndControl.value)) {
      this.hasDateError = true;
      taxYearStartControl.setErrors({'hasDateError': true});
      console.log('Invalid date');
      return false;
    } else {
      this.hasDateError = false;
    }
    console.log(this.data.input['taxYearStart'])
    console.log(this.data.input['taxYearEnd'])
    if(this.data.input['taxYearStart'] < this.minDate || this.data.input['taxYearStart'] > this.maxDate ){
      taxYearStartControl.setErrors({'hasDateRangeError': true});
      return false;
    }
    if(this.data.input['taxYearEnd'] < this.minDate || this.data.input['taxYearEnd'] > this.maxDate){
      taxYearEndControl.setErrors({'hasDateRangeError': true});
      return false;
    }

    // console.log('****** VALUES ******');
    // console.log(this.data.input['entity']);
    // console.log(this.data.input['title']);
    // console.log(this.data.input['state']);
    // console.log(this.data.input['auditType']);
    // console.log(this.data.input['fiscalYears']);
    // console.log(this.data.input['description']);
    // console.log(this.data.input['countries']);
    // console.log(this.data.input['local']);
    // console.log(this.data.input['other']);


    return true;
  }

  displayFn(auditStage: AuditStageType): string {
    return auditStage && auditStage.displayText ? auditStage.displayText : '';
  }
  displayStateFn(state: any): string {
    return state && state.stateName ? state.stateName : '';
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private _filter(value: any): AuditStageType[] {
    const filterValue = value.toLowerCase();
    console.log(filterValue);
    const audits =  this.auditTypes.filter(auditType => auditType.displayText.toLowerCase().indexOf(filterValue) === 0);
    if (audits.length === 0 ) {
      this.possibleNewAuditType = true;
      this.newFilteredItem = {
        displayText: value,
        id: value.toLowerCase(),
        stage: '',
        type: value
      };
    } else {
      this.possibleNewAuditType = false;
    }
    return audits;
  }

  private updateStateDropdown(commaSeparatedStateList: string) {
    const stateCodes = commaSeparatedStateList.split(',');
    stateCodes.forEach(s => {
      const state = this.stateList.find(o => o.stateCode === s);
      this.selectedStateList.push(state);
    });
  }

  onAddAudit() {
    this.auditTypes.push(this.newFilteredItem);
    this.fuseSplashScreen.show();
    const command = new PlatformCommand('AddCustomAuditTypeCommand', 'AuditTrackerApi');
    command.fieldValues['AuditType'] = this.newFilteredItem.type;
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
      this.fuseSplashScreen.hide();
      this.newFilteredItem = response.fieldValues['AuditModel'];
      this.inputForm.get('auditType').setValue(this.newFilteredItem);
      if (this.newFilteredItem == null) {
        this.snackBarService.showError('Can not Add Custom Audit Type');
      }
    }, err => {
      this.fuseSplashScreen.hide();
      this.snackBarService.showError(err.error.Message);
    });
  }

  private getAuditTypeById(id: string) {
    return this.auditTypes.find(ad => ad.id === id);
  }
  private getCountryByCode(id: string) {
    return this.countryList.find(country => country.code === id);
  }
  get entity(): FormControl {
    return this.inputForm.get('entity') as FormControl;
  }
  get countries(): FormControl {
    return this.inputForm.get('countries') as FormControl;
  }

  private getStates() {
    this.fuseSplashScreen.show();
    const query = new PlatformQuery();
    query.api = 'AuditTrackerApi';
    query.name = 'StateQuery';
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      this.fuseSplashScreen.hide();
      if (response.fieldValues['States']) {
        this.stateList = response.fieldValues['States'];
        this.stateFilterdOptions = this.inputForm.get('state').valueChanges
          .pipe(
            startWith(''),
            map(value => {
               const {stateName} = value as State;
              return typeof value === 'string' ? value : stateName;
            }),
            map(name => name ? this._filterState(name) : this.stateList.slice())
          );
      }
      this.isStateAvailable = true;
    }, err => {
      this.fuseSplashScreen.hide();
      console.error('Can not fetch state information', err);
      this.isStateAvailable = false;
    });
  }
  private _filterState(value: any): State[] {
    const filterValue = value.toLowerCase();
    console.log(filterValue);
    const states =  this.stateList.filter(state => state.stateName.toLowerCase().indexOf(filterValue) === 0);
    if (states.length === 0 ) {
      this.possibleNewState = true;
      this.newStateItem = {
        stateName: value,
        id: value.toLowerCase(),
        stateCode: '',
        countryCode: ''
      };
    } else {
      this.possibleNewState = false;
    }
    return states;
  }

  onAddState() {
    this.fuseSplashScreen.show();
    const command = new PlatformCommand('AddCustomStateCommand', 'AuditTrackerApi');
    command.fieldValues['StateName'] = this.newStateItem.stateName;
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
      this.fuseSplashScreen.hide();
      this.newStateItem = response.fieldValues['CustomState'];
      if (this.newStateItem == null) {
        this.snackBarService.showError('Can not Add Custom Audit Type');
      } else {
        this.stateList.push(this.newStateItem);
        this.inputForm.get('state').setValue(this.newStateItem);
      }
    }, err => {
      this.fuseSplashScreen.hide();
      this.snackBarService.showError(err.error.Message);
    });
  }

  remove(state: any): void {
    const index = this.selectedStateList.map(s => s.stateName.toLowerCase()).indexOf(state.stateName.toLowerCase());

    if (index >= 0) {
      this.selectedStateList.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.selectedStateList.push(event.option.value);
    this.stateInput.nativeElement.value = '';
    this.inputForm.get('state').setValue('');
  }

  onCountrySelected(value: any) {
    console.log(value);
    const codes = value.map(o => o.code);
    console.log(codes);
    this.filteredEntities = this.entities.filter( e => {
      console.log('-----');
      console.log(e);
      console.log(e.fieldValues.Country.code);
      console.log(codes.indexOf(e.fieldValues.Country.code) >= 0);
      return codes.indexOf(e.fieldValues.Country.code) >= 0;
    }  );
    console.log(this.filteredEntities);
  }



  clearAuditType($event) {
    this.inputForm.controls['auditType'].setValue('');

    this.openPanel($event);
  }

  openPanel(evt): void {
    evt.stopPropagation();
    this.inputAutoComplete.openPanel();
  }
}
